import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';
import { SingleSelectStepProps } from 'scenes/common/components/Steps/types';
import { SelectQuestion } from 'scenes/common/components/Questions';

const SingleSelectStep: FunctionComponent<SingleSelectStepProps> = ({
  onNext,
  question,
  stateKey,
  ariaLabel,
  defaultStateValue,
  options,
  helpText,
  required,
}) => {
  const {
    formState: { isValid },
    handleSubmit,
    control,
  } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        options={options}
        control={control}
        stateKey={stateKey}
        ariaLabel={ariaLabel}
        question={question}
        defaultValue={defaultStateValue}
        isLoading={false}
        helpText={helpText}
        required={required}
      />
      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default SingleSelectStep;
